/**
 * Checks if a specific feature is active for a given team.
 *
 * @param {object} team - The team object to check.
 * @param {array} features - The array of all available features.
 * @param {string} type - The type of feature to check.
 * @returns {boolean} - Returns true if the feature is active for the team, otherwise false.
 */
const isFeatureActiveForTeam = (team, features, type) => team.activeFeatures.some(featureId => {
    const feature = features.find(f => f.id === featureId.feature);
    return feature && feature.type === type;
});

const isFeatureActive = (features, type, team) => {
    const feature = features.find(f => f.type === type);
    return feature && feature.activableTeams.some(f => f.team.toString() === team.toString());
};

const isFeatureInActiveFeatures = (team, type) => team?.activeFeatures.some(feature => feature?.feature?.type === type);

module.exports = { isFeatureActiveForTeam, isFeatureActive, isFeatureInActiveFeatures };
